module.exports = __webpack_public_path__ + "img/netscape-now.688e763d.gif";